import { useContext, useMemo } from "react";
import styled from "styled-components";
import { LuPencilLine } from "react-icons/lu";

import { formatarData } from "../../Funcoes/FormatarData";
import { formatValorMoney } from '../../Funcoes/FormatValorMoney';
import { VerifyPermission } from "../../Funcoes/VerifyPermission";
import { AuthContext } from "../../Auth/AuthProvider";
import { useModal } from "../../contexts/ModalContext";

import Tabela from '../../Componentes/Utils/Tabela';
import ModalEditFolga from "./ModalEditFolga";

const Container = styled.div`
    width: 100%;
    background-color: #EBEBEB;
    border-radius: 15px;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 10px;
`
const Cabecalho = styled.div`
    width: 100%;
    height: 50px;
    background-color: #dbdbdb;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
`
const Titulo = styled.h2`
    margin: 0;
    font-size: 14px;
    font-weight: bold;
`
const Corpo = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    padding: 10px;
`
const TableCell = styled.td`
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`
const EditBtn = styled.button`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 1px solid #000;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0 auto;
    & svg{
        width: 14px;
        height: 14px;
        color: #000;
    }
`

const ContainerFolgaCampo = ({ folgasCampo, fetchData }) => {

    const { user } = useContext(AuthContext);
    const { isModalOpen, openModal } = useModal();

    const podeEditar = VerifyPermission(user, {
        modulo: "rh",
        submodulo: "colaborador",
        funcao: "edit_last_folga"
    });

    const ultimaFolgaEditavel = useMemo(() => {
        if (!folgasCampo || folgasCampo.length === 0) return null;

        const ordenadas = [...folgasCampo].sort((a, b) => {
            if (a.data === b.data) return (b.id || 0) - (a.id || 0);
            return (b.data || '').localeCompare(a.data || '');
        });

        const ultima = ordenadas[0];
        const now = new Date();
        const hoje = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

        return ultima?.data && ultima.data > hoje ? ultima : null;
    }, [folgasCampo]);

    const abrirEditFolga = () => {
        openModal('editLastFolga');
    }

    return (
        <>
            <Container>
                <Cabecalho>
                    <Titulo>FOLGAS DE CAMPO</Titulo>
                </Cabecalho>
                <Corpo>
                    <Tabela>
                        <thead>
                            <tr>
                                <th>VALOR</th>
                                <th>DATA</th>
                                <th>DIAS GOZO</th>
                                {podeEditar && <th style={{ width: 60 }}></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                folgasCampo?.length > 0 ? folgasCampo.map(item => {
                                    const isUltimaEditavel = ultimaFolgaEditavel && ultimaFolgaEditavel.id === item.id;

                                    return (
                                        <tr key={item.id}>
                                            <TableCell align="left">{"R$ " + (item?.valor ? formatValorMoney(item.valor) : formatValorMoney("0.00"))}</TableCell>
                                            <TableCell align="center">{item?.data ? formatarData(item.data) : '-'}</TableCell>
                                            <TableCell align="center">{item.dias_gozo}</TableCell>
                                            {podeEditar && (
                                                <TableCell align="center">
                                                    {isUltimaEditavel && (
                                                        <EditBtn type="button" onClick={abrirEditFolga} title="Editar última folga">
                                                            <LuPencilLine />
                                                        </EditBtn>
                                                    )}
                                                </TableCell>
                                            )}
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <TableCell align="center" colSpan={podeEditar ? 4 : 3}>
                                            COLABORADOR NÃO POSSUÍ FOLGAS DE CAMPO
                                        </TableCell>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Tabela>
                </Corpo>
            </Container>
            {isModalOpen('editLastFolga') && ultimaFolgaEditavel && (
                <ModalEditFolga
                    folga={ultimaFolgaEditavel}
                    fetchData={fetchData}
                />
            )}
        </>
    )
}

export default ContainerFolgaCampo;
